export const UPLOAD_EMPLOYEE_DATA = "UPLOAD_EMPLOYEE_DATA";
export const STORE_RESPONSE = "STORE_RESPONSE";

export const NEXT_STEP = "NEXT_STEP";
export const PREVIOUS_STEP = "PREVIOUS_STEP";

export const SAVE_TAX_CALC_INPUT = "SAVE_TAX_CALC_INPUT";
export const SAVE_COMP_DETAILS = "SAVE_COMP_DETAILS";
export const SAVE_EMPLOYEE_DATA = "SAVE_EMPLOYEE_DATA";

export const SHOW_INFO_MODAL = "SHOW_INFO_MODAL";
export const HIDE_INFO_MODAL = "HIDE_INFO_MODAL";

export const SHOW_MISC_MODAL = "SHOW_MISC_MODAL";
export const HIDE_MISC_MODAL = "HIDE_MISC_MODAL";

export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";

export const SHOW_ERROR = "SHOW_ERROR";
export const HIDE_ERROR = "HIDE_ERROR";

export const UPLOAD_IMAGE = "UPLOAD_IMAGE";

export const CALCULATE_TAX_TABLE = "CALCULATE_TAX_TABLE";
export const ADD_TOELAGEN = "ADD_TOELAGEN";
export const ADD_INHOUDINGEN = "ADD_INHOUDINGEN";
export const STORE_TAX_RESPONSE = "STORE_TAX_RESPONSE";
